"use strict";
exports.__esModule = true;
var ramda_1 = require("ramda");
var driftTypes_1 = require("../../utils/driftTypes");
var utils_1 = require("../utils");
var rbac_1 = require("./rbac");
var generateAppConfig = function (user) {
    if (utils_1.getIsRbacUser(user)) {
        return rbac_1["default"](user);
    }
    var config = {};
    var scopes = user.scopes, gates = user.gates;
    var isUnifiedUser = utils_1.getHasUnifiedNav(gates);
    var isCalendarUser = utils_1.getIsCalendarUser(scopes, gates);
    var isPhoneToPhoneUser = utils_1.getIsPhoneToPhoneUser(gates);
    var isAccountActivityUser = utils_1.getIsAccountActivityUser(gates);
    var isSavedViewsUser = utils_1.getIsSavedViewsUser(gates);
    var isSavedViewNotificationsUser = utils_1.getIsSavedViewNotificationsUser(gates);
    var isBrowserCallingUser = utils_1.getIsBrowserCallingUser(gates);
    var isChatToZoomUser = utils_1.getHasChatToZoom(gates);
    var isStandardOrAbove = utils_1.isStandardOrAboveOrg(gates) && !isCalendarUser;
    var isProOrAbove = utils_1.isProOrAboveOrg(gates) && !isCalendarUser;
    var isPremiumOrAbove = utils_1.isPremiumOrAboveOrg(gates) && !isCalendarUser;
    var isOrgAdmin = utils_1.getIsOrgAdmin(scopes) && !isCalendarUser;
    var isFree = utils_1.isFreeOrg(gates) && !isCalendarUser;
    var canSeeAllConvos = utils_1.getCanSeeAllConvos(scopes) && !isCalendarUser;
    var hasSavedRepliesGate = !!gates.saved_replies;
    config = ramda_1.set(ramda_1.lensProp('hasSavedReplies'), isStandardOrAbove || hasSavedRepliesGate, config);
    config = ramda_1.set(ramda_1.lensProp('hasNoParticipants'), scopes.includes(driftTypes_1.DriftScopesIF.convoNOPARTICIPANTS), config);
    config = ramda_1.set(ramda_1.lensProp('hasInviteTeammates'), isStandardOrAbove, config);
    config = ramda_1.set(ramda_1.lensProp('hasInviteTeam'), isPremiumOrAbove, config);
    config = ramda_1.set(ramda_1.lensProp('hasSFCardInSidebar'), isProOrAbove, config);
    config = ramda_1.set(ramda_1.lensProp('hasAutosyncToSFDCToggle'), isProOrAbove, config);
    config = ramda_1.set(ramda_1.lensProp('hasInternalNotes'), isStandardOrAbove, config);
    config = ramda_1.set(ramda_1.lensProp('hasLeaveConversation'), isStandardOrAbove, config);
    config = ramda_1.set(ramda_1.lensProp('hasProspectingView'), canSeeAllConvos || isOrgAdmin, config);
    config = ramda_1.set(ramda_1.lensProp('hasOptOutOfNewExperience'), isStandardOrAbove, config);
    config = ramda_1.set(ramda_1.lensProp('hasAgentAvailability'), !isCalendarUser, config);
    config = ramda_1.set(ramda_1.lensProp('hasSearch'), !isCalendarUser, config);
    config = ramda_1.set(ramda_1.lensProp('hasReplyToConversation'), !isCalendarUser, config);
    config = ramda_1.set(ramda_1.lensProp('hasPhoneToPhone'), isPhoneToPhoneUser, config);
    config = ramda_1.set(ramda_1.lensProp('hasAccountActivity'), isAccountActivityUser, config);
    config = ramda_1.set(ramda_1.lensProp('hasSavedViews'), isSavedViewsUser, config);
    config = ramda_1.set(ramda_1.lensProp('hasSavedViewNotifications'), isSavedViewNotificationsUser, config);
    config = ramda_1.set(ramda_1.lensProp('hasUnifiedNav'), isUnifiedUser, config);
    config = ramda_1.set(ramda_1.lensProp('hasBrowserToPhone'), isBrowserCallingUser, config);
    config = ramda_1.set(ramda_1.lensProp('hasChatToZoom'), isChatToZoomUser, config);
    config = ramda_1.set(ramda_1.lensProp('hasEditableEndUserAttributes'), !isCalendarUser, config);
    config = ramda_1.set(ramda_1.lensProp('hasAbilityToTag'), !isCalendarUser, config);
    config = ramda_1.set(ramda_1.lensProp('hasViewActivityTimeline'), !isCalendarUser, config);
    config = ramda_1.set(ramda_1.lensProp('hasEditableSavedReplies'), !isCalendarUser && !isFree, config);
    config = ramda_1.set(ramda_1.lensProp('hasShowAllConversationsInSidebar'), isFree, config);
    config = ramda_1.set(ramda_1.lensProp('hasRemoveParticipantFromConversation'), isOrgAdmin, config);
    config = ramda_1.set(ramda_1.lensProp('hasInstallWidget'), isOrgAdmin, config);
    config = ramda_1.set(ramda_1.lensProp('hasEditableTags'), isOrgAdmin, config);
    config = ramda_1.set(ramda_1.lensProp('hasCalendarRouting'), utils_1.hasCalendarRouting(gates), config);
    config = ramda_1.set(ramda_1.lensProp('hasMultiParticipantMeetings'), isProOrAbove, config);
    config = ramda_1.set(ramda_1.lensProp('hasABMNotifications'), !!gates.ABM, config);
    config = ramda_1.set(ramda_1.lensProp('hasConversationRating'), isStandardOrAbove, config);
    config = ramda_1.set(ramda_1.lensProp('hasTargetingAuditLog'), isOrgAdmin, config);
    config = ramda_1.set(ramda_1.lensProp('hasRoutingAuditLog'), isOrgAdmin, config);
    config = ramda_1.set(ramda_1.lensProp('hasConversationSections'), isStandardOrAbove && (canSeeAllConvos || isOrgAdmin), config);
    config = ramda_1.set(ramda_1.lensProp('hasMyConversations'), true, config);
    config = ramda_1.set(ramda_1.lensProp('hasAllConversations'), scopes.includes(driftTypes_1.DriftScopesIF.convoALL) || scopes.includes(driftTypes_1.DriftScopesIF.org_admin), config);
    config = ramda_1.set(ramda_1.lensProp('hasAdminNotificationSettings'), utils_1.getIsOrgAdmin(scopes), config);
    config = ramda_1.set(ramda_1.lensProp('hasAccountActivityNotifications'), true, config);
    config = ramda_1.set(ramda_1.lensProp('hasConvoNotifications'), true, config);
    config = ramda_1.set(ramda_1.lensProp('hasSendSMS'), utils_1.getHasSMSConversations(gates) && !isCalendarUser, config);
    return config;
};
exports["default"] = generateAppConfig;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@driftt/app-config/dist/appConfigs/conversationsDesktop/index.js
// module id = GJjx
// module chunks = 88